import { api } from "../../services/api";

const service_path = "/notifications.php";

function authConfig() {
    return { withCredentials: true };
}

export async function getNotifications(params = {}) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== "" && value != null) {
            search.set(key, String(value));
        }
    });
    const query = search.toString();
    return api.get(query ? `${service_path}?${query}` : service_path, authConfig());
}

export async function markNotificationRead(id) {
    return api.patch(service_path, { id }, authConfig());
}

export async function markAllNotificationsRead() {
    return api.patch(service_path, { mark_all: true }, authConfig());
}
